define('presentation/settings/reports/facades/reportsFacade',[
    'externalDependencies/clientWebSocket',
    'presentation/common/dateTimeValue',
    'presentation/settings/reports/presentationObjects/reportPresentationObject',
    'settings/navigationConfiguration',
], function() {
    const DateTimeValueConstructor = require('presentation/common/dateTimeValue');
    const ScheduledReportPresentationObjectConstructor = require('presentation/settings/reports/presentationObjects/reportPresentationObject');

    const _navigationConfiguration = require('settings/navigationConfiguration');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const _scheduledReportSocket = clientWebSocket.forApplication("scheduledReport");

    let _promiseFactory = null;

    const _buildScheduledReportPresentationObject = (scheduledReport) => {
        const { scheduledReportId, subject, deliveryFrequency, deliveryFormat, timeframe, createdDateTime, updatedDateTime } = scheduledReport;
        let scheduledReportPresentationObject = new ScheduledReportPresentationObjectConstructor();
        scheduledReportPresentationObject.scheduledReportId = scheduledReportId;
        scheduledReportPresentationObject.subject = subject;
        scheduledReportPresentationObject.deliveryFrequency(deliveryFrequency.toString());
        scheduledReportPresentationObject.deliveryFormat(deliveryFormat.toString());
        scheduledReportPresentationObject.timeframe = timeframe;
        scheduledReportPresentationObject.createdDateTime = new DateTimeValueConstructor(createdDateTime);
        scheduledReportPresentationObject.modifiedDateTime = new DateTimeValueConstructor(updatedDateTime);
        scheduledReportPresentationObject.editScheduledReportUrl = _navigationConfiguration.routesById.editReport.baseUrl + scheduledReportId;
        return scheduledReportPresentationObject;
    };

    const _getScheduledReports = () => {
        return _promiseFactory.defer((promise) => {
            _scheduledReportSocket.send("retrieveAll", {}, (response) => {
                const scheduledReports = response.map((scheduledReport) => {
                    return _buildScheduledReportPresentationObject(scheduledReport);
                });
                promise.resolve(scheduledReports);
            });
        });
    };

    const _deleteScheduledReport = (scheduledReportId) => {
        return _promiseFactory.defer((promise) => {
            _scheduledReportSocket.send("deleteScheduledReport", { scheduledReportId }, (response) => {
                if (response.isSuccessful === false) {
                    promise.reject();
                    return;
                }
                promise.resolve();
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    const _dispose = () => {
        _scheduledReportSocket.disposeOfEvents();
    };

    return function() {
        const self = this;

        self.init = _init;
        self.dispose = _dispose;

        self.deleteScheduledReport = _deleteScheduledReport;
        self.getScheduledReports = _getScheduledReports;
    };
});

